














import { Vue, Component, Prop } from "vue-property-decorator";
import { HTMLEncode } from '../../../utils'
enum READ_STATUS {
  NOT_READ = 3,
  READ = 4
}
@Component({
  name: "WhatsappMessage"
})
export default class WhatsappMessage extends Vue {
  private created() { }
  @Prop({
    default: {
      messagecontent: '',
      messagetimestamp: 0,
      fromme: true,
      status: 0
    }
  }) public messageData?: {
      messagecontent: string,
      messagetimestamp: number,
      fromme: boolean,
      status: any
  };
  get translatedMessage() {
    let message = this.messageData?.messagecontent
    if (!message) return ''
    message = HTMLEncode(message)
    return message
  }
  get readStatusMark() {
    const readStatusMarkMap = {
      [READ_STATUS.NOT_READ]: {
        'el-icon-check': true
      },
      [READ_STATUS.READ]: {
        'el-icon-finished': true
      }
    }
    if (this.messageData?.fromme && this.messageData?.status) {
      return readStatusMarkMap[this.messageData.status === READ_STATUS.READ ? READ_STATUS.READ : READ_STATUS.NOT_READ]
    }
    return {}
  }
}
